import axios from "axios";

import ConnUrls from '../Connections/ConnectURL'


const chekckKopon = async (obj) => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + "kopons/checkKoponValid", { params: obj });
    return (dFromF.data);
}

const reserveKopon = async (obj) => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + "kopons/reserveKopon", { params: obj });
    return (dFromF.data);
}

const releaseKoponReservation = async (obj) => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + "kopons/releaseKoponReservation", { params: obj });
    return (dFromF.data);
}


export default {
    chekckKopon,
    reserveKopon,
    releaseKoponReservation
};